<template>
  <div class="cases__inner" v-if="cases.length > 0">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="item in cases" v-bind:key="item.id">
        <a
          class="cases__inner--case"
          :href="item.permalink"
          :title="item.title"
        >
          <div class="cases__inner--case__thumbnail">
            <img
              :src="item.thumbnails.lz"
              :data-src="item.thumbnails.lg"
              :data-srcset="`${item.thumbnails.md} 768w, ${item.thumbnails.lg} 992w`"
              :alt="item.title"
              class="lazyload blur-up"
              v-if="item.has_thumbnail"
            />
          </div>
          <div class="cases__inner--case__content">
            <div class="cases__inner--case__content--logo">
              <img
                :src="item.logo.lz"
                :data-src="item.logo.md"
                :data-srcset="`${item.logo.md} 768w`"
                :alt="item.title"
                class="lazyload blur-up"
              />
            </div>
            <div
              v-html="item.title"
              class="cases__inner--case__content--title"
            ></div>
          </div>
          <div class="cases__inner--case__content--button">
            <a class="button normal" :title="item.title" :href="item.permalink">
              <span>{{ reading }}</span>
            </a>
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div class="cases__inner--arrows">
      <div class="cases-button-prev"></div>
      <div class="cases-button-next"></div>
    </div>
  </div>
</template>

<script>
/* global casesResults */
/* global continueReading */
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      cases: casesResults,
      reading: continueReading,
      swiperOptions: {
        slidesPerView: 1,
        centerInsufficientSlides: true,
        autoHeight: false,
        spaceBetween: 0,
        navigation: {
          nextEl: ".cases-button-next",
          prevEl: ".cases-button-prev",
        },
        breakpoints: {
          769: {
            slidesPerView: 2,
            spaceBetween: 25.5,
            autoHeight: true,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 25.5,
            autoHeight: true,
          },
          1408: {
            slidesPerView: 4,
            spaceBetween: 25.5,
            autoHeight: true,
          },
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
};
</script>
